import { render, staticRenderFns } from "./DashDemandsList.vue?vue&type=template&id=2b36ba4b&scoped=true&"
import script from "./DashDemandsList.vue?vue&type=script&lang=js&"
export * from "./DashDemandsList.vue?vue&type=script&lang=js&"
import style0 from "./DashDemandsList.vue?vue&type=style&index=0&id=2b36ba4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36ba4b",
  null
  
)

export default component.exports